import withHandledGroupFinTermData
  from "../../../pages/Contracts/pages/Contract/pages/GroupFinTermsView/groupFinTermsView/GroupFinTermCard/withHandledGroupFinTermData";
import GroupFinTermBlock from "../GroupFinTermBlock/GroupFinTermBlock";

const ConnectedGroupFinTermBlock = withHandledGroupFinTermData(GroupFinTermBlock);

export default ConnectedGroupFinTermBlock;